export default "__VITE_ASSET__4e812ff1__"